







































































































































import { Component, Prop, Watch } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import draggable from 'vuedraggable'
import { iconMap } from '@/util/resMap'
import { saveList, sendRes, getMyList } from '@/api/res'
import { toMap } from '@/fn/array'
import { Tooltip, Modal, message } from 'ant-design-vue'
import dragOut from '@/util/dragOut'
import { alert, success, confirm } from '@/util/modal'
import event from '@/fn/event'
import shortid from 'shortid'
import { getPlayList, savePlayList, getProps } from '@/util/intent'
import { getMyPlayList } from './data'

@Component({
  components: {
    draggable,
    Tooltip,
    Modal
  }
})
// ant-design-vue api https://www.antdv.com/components/modal-cn/
export default class PlayClassList extends ViewBase {
  @Prop({ default: 0 }) playId!: any
  @Prop({ default: 'Play' }) playStatus!: string

  saveListName = ''

  iconMap = iconMap

  targetCourse: any = ''

  myCourseList = []

  hasFetchMyCourseList: boolean = false

  classTitle: string = ''

  selectSaveListName = ''

  selectAddMyPlayList = false

  inputAddMyPlayList = false

  // 发送资源
  sendListModel = false

  sendListLoading = false

  // 我的清单
  myPlayLoading = false

  myPlayList: any[] = []

  playList: any[] = []

  // 上一次播放的id
  oldPlayId: any = null

  // 上一次播放状态
  oldPlay: any = 'Play'

  saveListModel: boolean = false

  setExplainModel: boolean = false

  saveListLoading: boolean = false

  clearListModel: boolean = false

  gotoPlayVisible: boolean = false
  get locale() {
    return this.$store.getters.currentLocale
  }

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  get i18nPlay() {
    const value = this.$t('playPane')
    return value as any
  }

  get getPlayList() {
    return this.$store.state.playList
  }

  get playALL() {
    return this.$store.state.playALL
  }

  get deviceList() {
    return this.$store.state.deviceList
  }

  async fetchMyCourseList() {
    // if(this.hasFetchMyCourseList) return
    try {
      const res = await getMyList()
      if (res.data && res.data.length) {
        this.myCourseList = res.data.map((el: any) => ({
          ...el,
          _id: shortid.generate()
        }))
        // this.hasFetchMyCourseList = true
      }
    } catch (ex) {
      this.handleError(ex)
    } finally {
      //
    }
  }

  itemAdd({ item, newIndex }: any) {
    const data = item.dataset
  }

  gotoPlay(item: any) {
    // this.playId = item.id
    // this.$router.push({
    //   name: 'playIndex',
    //   params: {
    //     id: item.id,
    //     resourceId: item.id
    //   }
    // })
    this.$store.commit('setPlayId', item.id)
    this.$emit('goto-play', item)
  }

  // 手动控制去上课提示的显示隐藏
  mouseenter() {
    this.gotoPlayVisible = true
  }

  mouseleave() {
    this.gotoPlayVisible = false
  }

  handleSelect(v: any) {
    this.targetCourse = v
  }
  async changeAddMyPlayList(value: any) {
    this.selectSaveListName = value
    if (value) {
      this.selectAddMyPlayList = false
      this.inputAddMyPlayList = true
    } else {
      this.selectAddMyPlayList = false
      this.inputAddMyPlayList = false
    }
  }
  // 加载我的清单
  async loadMyPlayList() {
    this.myPlayLoading = true
    try {
      const { data } = await getMyPlayList()
      this.myPlayList = (data || []).filter((it: any) => it.resource_list.length > 0)
    } catch (ex) {
      this.handleError(ex)
    } finally {
      this.myPlayLoading = false
    }
  }

  async saveListClick() {
    if (this.playList.length == 0) {
      alert(this.i18nPlay.listIsEmpty)
      return
    }
    this.fetchMyCourseList()
    this.saveListModel = true
    this.targetCourse = ''
    this.saveListName = ''
  }

  async saveListSubmit() {
    const ids = {}
    this.playList.map(it => {
      const tmp: any = {}
      tmp[it.id] = it.use_explain
      Object.assign(ids, tmp)
    })
    let title = this.saveListName.trim()
    const id = this.targetCourse
    if (!id && title == '') {
      alert(this.i18nPlay.titleEmpty)
      return
    }
    // console.log(this.$i18n.locale)
    if (this.$i18n.locale == 'zh') {
      if (title.length > 20) {
        alert(this.i18n.vsider.tipmore)
        return
      }
    } else {
      if (title.length > 40) {
        alert(this.i18n.vsider.tipmore)
        return
      }
    }

    if (id) {
      title = (this.myCourseList.find((el: any) => el.id === id) as any).course_title
    }
    this.saveListLoading = true
    try {
      const pdata = {
        id,
        title,
        resource_ids: ids
      }
      await saveList(pdata)
      message.success(this.i18nPlay.saveDone)
      this.classTitle = title
      this.saveListModel = false
    } catch (ex) {
      this.handleError(ex)
    } finally {
      this.$store.commit('setNeedRefreshMyCourse', true)
      this.saveListLoading = false
    }
  }
  // 编辑课程
  async goeditClick() {
    this.gotoPlayVisible = false
    this.$router.push({
      name: 'courseEdit'
    })
  }

  // 清除课程
  clearListModal() {
    this.clearListModel = true
  }

  cancelClearModal() {
    this.clearListModel = false
  }
  async clearList() {
    if (this.playList.length == 0) {
      alert(this.i18nPlay.listIsEmpty)
      return
    }

    // await confirm(this.i18nPlay.clearListTip, this.i18nPlay.clearListConfirm)
    this.playList = []
    this.clearListModel = false
  }

  // 发送资源

  sentResClickConfirm() {
    if (this.playList.length == 0) {
      alert(this.i18n.listIsEmpty)
      return
    }
    this.sendListModel = true
  }
  async sendResClick() {
    this.sendListModel = false
    const devices = this.$store.state.deviceList
    const deviceIds = devices.map((it: any) => it.id)
    if (deviceIds.length == 0) {
      alert(this.i18n.deviceIsEmpty)
      return
    }
    this.sendListLoading = true
    // await confirm(this.i18n.sentListTip, this.i18n.sendListTipConfrim)
    try {
      const pdata = {
        type: 'override',
        rids: this.playList.map(it => it.id),
        ids: deviceIds
      }
      await sendRes(pdata)
      success(this.i18n.resSending, this.i18n.resSendDone)
    } catch (ex) {
      this.handleError(ex)
    } finally {
      this.sendListLoading = false
    }
  }
  created() {
    this.playList = this.$store.state.playList
    this.classTitle = this.$store.state.playALL.title
  }
  @Watch('playStatus')
  watchPlayStatus() {
    if (this.$store.state.playInfo.id) {
      this.oldPlayId = this.$store.state.playInfo.id
      this.oldPlay = this.$store.state.playInfo.status
    }
  }
}
